import { Stack } from '@mui/material';
import { Logo } from './Logo';
import './PrintOnlyLogo.css';

export const PrintOnlyLogo = () => {
  return (
    <>
      <Stack direction="row" justifyContent="center" alignItems="center" className="print-only">
        <Logo colorMode="light" size="medium" />
      </Stack>
    </>
  );
};
